// src/component/groupActivity2026Audience.js
//
// 「2026 グループ活動」の公開範囲ロジック。
//
// audience = "admin" : 管理者のみに表示（テスト中）
// audience = "all"   : 4期（MM2026）支払い済みユーザーに表示
//                       「全員」ではなく「4期に在籍しているユーザー」だけが対象。
//                       銀行振込／クレジットカード のいずれかで paymentPhase = "4" を持つ人。
//
// 管理者は audience 設定に関わらず常に見える（プレビュー／代理運用のため）。

import { GA2026_AUDIENCE } from "./groupActivity2026Defaults";

const PAYMENT_PHASE_2026 = "4";

/**
 * ユーザードキュメントから「4期に在籍しているか」を判定。
 * `payments` 配列に `paymentPhase === "4"` のレコードが1つでもあれば true。
 * 決済方法（銀行振込／クレジットカード／セカイムラ等の独自値／2期無料招待 など）
 * は問わない方針。MM2026JoinDialogLauncher は決済方法でも絞っているが、
 * 当機能（2026 グループ活動）はセカイムラ民も含めたい意図のため緩めにしている。
 */
export function is4kiPaidUser(userData) {
  if (!userData) return false;
  const payments = Array.isArray(userData.payments) ? userData.payments : [];
  return payments.some((p) => p?.paymentPhase === PAYMENT_PHASE_2026);
}

/**
 * 公開範囲設定と当該ユーザーの状態から、見せて良いかどうかを判定。
 *
 * @param {Object} args
 * @param {"admin"|"all"} args.audience
 * @param {boolean} args.isAdmin
 * @param {Object|null} args.userData - users/{uid} のスナップショットデータ
 * @returns {boolean}
 */
export function canSeeGroupActivity2026({ audience, isAdmin, userData }) {
  // 管理者は常に見える（テスト・代理運用のため）
  if (isAdmin) return true;
  if (audience === GA2026_AUDIENCE.ALL) {
    return is4kiPaidUser(userData);
  }
  return false; // audience === "admin" で非管理者は見えない
}
